import s from "./CdrCard.vue2.mjs";
import o from "./styles/CdrCard.module.scss.mjs";
import r from "../../_virtual/_plugin-vue_export-helper.mjs";
const t = {
  $style: o
}, f = /* @__PURE__ */ r(s, [["__cssModules", t]]);
export {
  f as default
};
